var _a, _b, _c, _d, _e, _f;
import { treeItemClasses } from '@mui/lab/TreeItem';
import { gray40opacity05, gray40opacity10 } from '../../../colors/gray';
import { listStylesDark } from '../components/MuiListItem';
import { rem } from '../../../utils/rem';
export var MuiTreeView = {
    styleOverrides: (_a = {},
        _a["& .".concat(treeItemClasses.root)] = (_b = {},
            _b["& .".concat(treeItemClasses.content)] = (_c = {},
                _c["&.".concat(treeItemClasses.focused)] = {
                    outline: listStylesDark.focusVisible.outline,
                    backgroundColor: listStylesDark.focusVisible.backgroundColor,
                },
                _c["&:hover"] = {
                    backgroundColor: listStylesDark.hover.backgroundColor,
                },
                _c["&.".concat(treeItemClasses.selected)] = {
                    backgroundColor: listStylesDark.selected.backgroundColor,
                    '&:hover': {
                        backgroundColor: listStylesDark.selectedHover.backgroundColor,
                    },
                },
                _c),
            _b),
        _a),
    customOverrides: {
        filled: (_d = {},
            // Only root has a background color set to filled
            _d["& > li.".concat(treeItemClasses.root, " > .").concat(treeItemClasses.content, ":not(.").concat(treeItemClasses.selected, ")")] = {
                backgroundColor: gray40opacity05,
                '&:hover': {
                    backgroundColor: listStylesDark.hover.backgroundColor,
                },
            },
            _d),
        bordered: (_e = {},
            _e["& .".concat(treeItemClasses.root)] = (_f = {},
                _f["& .".concat(treeItemClasses.content)] = {
                    borderBottom: "".concat(rem(1), " solid ").concat(gray40opacity10),
                },
                _f),
            _e),
    },
};
